{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Sélectionner un élément",
  "tableResizer": "Redimensionneur"
}
